import { useTranslation } from 'react-i18next';
import { FormSection, LinkButton } from '../../components/ui';

/** Plan, usage and fees live on /plan; Profile only points there. Owner and Admin only. */
export const PlanSection = () => {
    const { t } = useTranslation('billing');
    return (
        <FormSection title={t('profile.title')}>
            <p className="text-small text-muted">{t('profile.body')}</p>
            <div>
                <LinkButton to="/plan" variant="outline">
                    {t('profile.link')}
                </LinkButton>
            </div>
        </FormSection>
    );
};
